<template>
  <header class="main-header">
    <template v-if="!$route.name.includes('ViewContainer')">
      <button v-if="$route.name.indexOf('Update') < 0" type="button" class="menu-button" @click="closeMenu">
        <span>Меню</span>
      </button>
      <button v-if="$route.name.indexOf('Update') > -1" type="button" class="menu-button back-click" @click="onClickBack">
        <span>Назад</span>
      </button>
    </template>
    <template v-else>
      <button type="button" class="menu-button back-click" @click="onClickBack">
        <span>Назад</span>
      </button>
    </template>

    <div class="header-title">
      <div class="up-title">{{ upTitle }}</div>
      <div class="main-title">{{ mainTitle }}</div>
    </div>

    <i class="spacer" />

    <notification-center v-if="isAuthorized" />

    <div v-if="$route.name.indexOf('Update') > -1" class="header-buttons">
      <regular-button
        v-if="$route.name !== 'UpdateProblem'"
        v-hidden="`${$route.params.containerType}-waste-area:edit waste-source:edit`"
        type="button"
        :rounded="true"
        class="save-button"
        @click="onSaveUpdate"
      >
        сохранить
      </regular-button>
      <regular-button
        v-if="$route.name === 'UpdateProblem'"
        type="button"
        :rounded="true"
        class="save-button"
        @click="onSaveProblem"
      >
        сохранить
      </regular-button>
      <regular-button type="button" class="cancel-button" :blank="true" @click="onClickBack">отменить</regular-button>
    </div>

    <div v-if="isActiveDeleting" class="delete-info">
      <div class="delete-info__title">
        <span>{{ deleteTitle }}</span>
      </div>
      <div class="delete-info__cancel-delete" @click="onCancelDeleting">отменить удаление</div>
      <button type="button" class="delete-info__close" @click="closeDeleteInfo"></button>
    </div>
  </header>
</template>

<script>
import { mapState } from "vuex";
import NotificationCenter from "../components/NotificationCenter";
import RegularButton from "../components/RegularButton";

export default {
  name: "Header",
  components: {
    NotificationCenter,
    RegularButton
  },
  props: {
    closeMenu: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      upTitle: "",
      mainTitle: "",
      oldData: {},
      type: "",
      deleteTitle: "Вы удалили элемент. Вы можете отменить удаление если это сделано случайно",
      isActiveDeleting: false,
      deleteTimeout: null
    };
  },
  computed: {
    ...mapState(["isAuthorized"]),
    ...mapState({
      routerLimitedHistory: state => state.routerLimitedHistory.history
    })
  },
  mounted() {
    this.$root.$on("onChangeHeader", (data, type) => {
      this.upTitle = data.upTitle;
      this.mainTitle = data.mainTitle;
      this.type = type;
    });
    this.$root.$on("onShowHeaderDeletePopup", () => {
      this.isActiveDeleting = true;
      clearTimeout(this.deleteTimeout);
      this.deleteTimeout = setTimeout(() => {
        this.closeDeleteInfo();
      }, 4000);
    });
  },
  beforeDestroy() {
    this.$root.$off("onDeleteItem");
    this.$root.$off("onChangeHeader");
  },
  methods: {
    onClickBack() {
      if (this.$route.name === "UpdateContainer") {
        if (this.routerLimitedHistory.length === 2 && this.routerLimitedHistory[1] === "/terr-schema/map") {
          this.$router.push({ name: "TerrSchemaMap" });
          return;
        } else {
          if (this.type === "nestedContainer") {
            this.$root.$emit("onCancelNestedContainer");
            return;
          }
          this.$router.push({ name: "ContainersTable" });
        }
      }

      if (this.$route.name === "UpdateWasteSource") {
        if (this.type === "nestedWasteSource") {
          this.$root.$emit("onCancelNestedContainer");
          return;
        }
        this.$router.push({ name: "WasteSourcesTable" });
      }

      if (this.$route.name === "UpdateVehicle") {
        this.$router.push({ name: "RoutesFleet" });
      }

      if (this.$route.name === "UpdateProblem") {
        if (this.type === "nestedContainer") {
          this.$root.$emit("onCancelNestedContainer");
          this.type = "";
          return;
        }
        this.$router.push({ name: "ProblemsTable" });
      }

      if (this.$route.name === "ViewContainer") {
        this.$router.push({ name: "TerrSchemaMap" });
      }

      if (this.$route.name === "UpdateWasteHandler") {
        if (this.type === "nestedWasteHandler") {
          this.$root.$emit("onCancelNestedContainer");
          return;
        }
        this.$router.push({ name: "WasteHandlerTable" });
      }
    },
    onSaveProblem() {
      if (this.type === "nestedContainer") {
        this.$root.$emit("onSaveNestedContainer");
        return;
      }
      this.$root.$emit("onSaveProblem");
    },
    onSaveUpdate() {
      if (this.$route.name === "UpdateContainer") {
        if (this.type === "nestedContainer") {
          this.$root.$emit("onSaveNestedContainer");
          return;
        }
        this.$root.$emit("saveContainerUpdate");
      }

      if (this.$route.name === "UpdateVehicle") {
        this.$root.$emit("saveVehicleUpdate");
      }

      if (this.$route.name === "UpdateWasteSource") {
        if (this.type === "nestedWasteSource") {
          this.$root.$emit("onSaveNestedWasteSource");
          return;
        }
        this.$root.$emit("saveWasteSourceUpdate");
      }

      if (this.$route.name === "UpdateWasteHandler") {
        if (this.type === "nestedWasteHandler") {
          this.$root.$emit("onSaveNestedWasteHandler");
          return;
        }
        this.$root.$emit("saveWasteHandlerUpdate");
      }

      if (this.$route.name === "UpdateWasteManagementFacility") {
        this.$root.$emit("saveUpdate__waste-management-facilities");
      }
    },
    closeDeleteInfo() {
      clearTimeout(this.deleteTimeout);
      this.isActiveDeleting = false;
      this.$root.$emit("onDeleteItems");
    },
    onCancelDeleting() {
      clearTimeout(this.deleteTimeout);
      this.isActiveDeleting = false;
      this.$root.$emit("onCancelDeleteItems");
    }
  }
};
</script>
